dmx.Component('bs5-theme-switch', {

  attributes: {
    icons: {
      type: String,
      default: 'bi',
      enum: ['bi', 'fa'],
    },

    textDark: {
      type: String,
      default: 'Dark',
    },

    textLight: {
      type: String,
      default: 'Light',
    },

    textAuto: {
      type: String,
      default: 'Auto',
    },
    menuText: {
      type: String,
      default: '',
    },
    manager: {
      type: String,
      default: '',
    },
  },

  events: {
    change: Event,
  },

  init (node) {
    this._icons = {
      bi: {
        auto: 'bi-circle-half',
        check: 'bi-check2',
        dark: 'bi-moon-stars-fill',
        light: 'bi-sun-fill',
      },
      fa: {
        auto: 'fa-adjust',
        check: 'fa-check',
        dark: 'fa-moon fa-moon-o',
        light: 'fa-sun fa-sun-o',
      },
    };

    this._prefix = node.id;
    this.props.theme = 'auto';
	
    if (this.props.manager) {
      this.$watch(`${this.props.manager}.theme`, theme => {
        this.props.theme = theme;
      });
    }
  },

  render (node) {
    const icons = this._icons[this.props.icons];
    const isNavItem = node.classList.contains('nav-item') || node.parentNode.classList.contains('nav-item');

    node.classList.add('dropdown');

    node.innerHTML = `
      <button class="btn ${isNavItem ? 'btn-link nav-link' : 'btn-primary'} py-2 dropdown-toggle d-flex align-items-center" id="${this._prefix}-theme" type="button" aria-expanded="false" data-bs-toggle="dropdown" aria-label="Toggle theme (auto)">
        <i class="${this.props.icons} ${icons.auto} ${this.props.icons == 'fa' ? 'my-1' : ''} theme-icon-active"></i> 
		${this.props.menuText ? `<span class="ms-2">${this.props.menuText}</span>` : ''}
        <span class="visually-hidden" id="${this._prefix}-theme-text">Toggle theme</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="${this._prefix}-theme-text">
        <li>
          <button type="button" class="dropdown-item d-flex align-items-center" data-bs-theme-value="light" aria-pressed="false">
            <i class="${this.props.icons} ${icons.light} me-2 opacity-50"></i>
            ${this.props.textLight}
            <i class="${this.props.icons} ${icons.check} ms-auto d-none"></i>
          </button>
        </li>
        <li>
          <button type="button" class="dropdown-item d-flex align-items-center" data-bs-theme-value="dark" aria-pressed="false">
            <i class="${this.props.icons} ${icons.dark} me-2 opacity-50"></i>
             ${this.props.textDark}
            <i class="${this.props.icons} ${icons.check} ms-auto d-none"></i>
          </button>
        </li>
        <li>
          <button type="button" class="dropdown-item d-flex align-items-center" data-bs-theme-value="auto" aria-pressed="true">
            <i class="${this.props.icons} ${icons.auto} me-2 opacity-50"></i>
             ${this.props.textAuto}
            <i class="${this.props.icons} ${icons.check} ms-auto d-none"></i>
          </button>
        </li>
      </ul>
    `;

    node.querySelectorAll('[data-bs-theme-value]').forEach(toggle => {
      toggle.addEventListener('click', () => {
        	this.props.theme = toggle.getAttribute('data-bs-theme-value');
          this._setTheme(this.props.theme);
          node.querySelector(`#${this._prefix}-theme`).focus();
      });
    });

    this.performUpdate(new Map());
  },

  performUpdate (updatedProps) {
    const icons = this._icons[this.props.icons];

    this.$node.querySelectorAll('[data-bs-theme-value]').forEach(element => {
      if (element.getAttribute('data-bs-theme-value') === this.props.theme) {
        element.classList.add('active');
        element.setAttribute('aria-pressed', 'true');
        element.querySelector('.' + icons.check).classList.remove('d-none');
      } else {
        element.classList.remove('active');
        element.setAttribute('aria-pressed', 'false');
        element.querySelector('.' + icons.check).classList.add('d-none');
      }
    });

    const activeThemeIcon = this.$node.querySelector('.theme-icon-active');
    Object.values(icons).forEach(cls => activeThemeIcon.classList.remove(...cls.split(' ')));
    activeThemeIcon.classList.add(...icons[this.props.theme].split(' '));
    
    const themeSwitcher = this.$node.querySelector(`#${this._prefix}-theme`);
    themeSwitcher.setAttribute('aria-label', `Toggle theme (${this.props.theme})`);

    if (updatedProps.has('manager')) {
      if (this.props.manager) {
        if (this._watcher) this._watcher();
        this._watcher = dmx.effect(() => {
          this.props.theme = this.parse(`${this.props.manager}.theme`);
        });
      }
    }
  },

  destroy () {
    if (this._watcher) this._watcher();
  },

  _setTheme (theme) {
    if (this.props.manager) {
      this.parse(`${this.props.manager}.setTheme("${theme}")`);
    }
    this.dispatchEvent('change', {}, { theme });
  },

});